"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import {
  Dialog,
  DialogCancel,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogForm,
  DialogHeader,
  DialogSubmit,
  DialogTitle,
} from "@/components/ui/dialog";
import type { ContactView } from "@/lib/views";
import { mitgliedSpeichern } from "@/app/(app)/mitglieder/actions";
import { MitgliedFormular, pruefeMitglied } from "./mitglied-formular";
import type { ActionError } from "@/lib/action-result";

export function MitgliedDialog({
  open,
  onClose,
  kontakt,
}: {
  open: boolean;
  onClose: () => void;
  kontakt?: ContactView;
}) {
  const router = useRouter();
  const [fehler, setFehler] = useState<Record<string, string>>({});
  const neu = !kontakt;

  async function speichern(daten: FormData) {
    const f = pruefeMitglied(daten);
    setFehler(f);
    if (Object.keys(f).length) return { error: Object.values(f)[0]!, field: Object.keys(f)[0] };
    const ergebnis = await mitgliedSpeichern(kontakt?.id ?? null, daten);
    const fehlschlag = "error" in ergebnis ? (ergebnis as ActionError) : null;
    if (fehlschlag?.field) setFehler({ [fehlschlag.field]: fehlschlag.error });
    return ergebnis;
  }

  return (
    <Dialog open={open} onClose={onClose} size="wide">
      <DialogHeader>
        <DialogTitle>{neu ? "Mitglied anlegen" : `${kontakt.displayName} bearbeiten`}</DialogTitle>
        <DialogDescription>
          {neu ? "Nur Name ist Pflicht — alles andere lässt sich später ergänzen." : "Änderungen werden im Verlauf festgehalten."}
        </DialogDescription>
      </DialogHeader>
      <DialogForm
        action={speichern}
        success={neu ? "Mitglied angelegt" : "Gespeichert"}
        onSuccess={(r) => {
          onClose();
          if (neu && "id" in r) router.push(`/mitglieder/${r.id}`);
          else router.refresh();
        }}
      >
        <DialogContent>
          <MitgliedFormular kontakt={kontakt} fehler={fehler} />
        </DialogContent>
        <DialogFooter>
          <DialogCancel />
          <DialogSubmit>{neu ? "Mitglied anlegen" : "Speichern"}</DialogSubmit>
        </DialogFooter>
      </DialogForm>
    </Dialog>
  );
}
